import React from "react";

import LastFeedback from "../tepl-cards/LastFeedback";

const TrainerFeedbacks = ({
  filters,
  sendableQPs,
  queryParametersForAll,
  isFront,
}) => {
  return (
    <div className="settlementGraphContainer spanTwo">
      <div className="settleGraphTitleAndFilter">
        <h5 className="tite">Feedbacks</h5>
      </div>

      <div className="settleGraphBody">
        <div className="graphedCard">
          <LastFeedback
            filters={filters}
            sendableQPs={sendableQPs}
            queryParametersForAll={queryParametersForAll}
            isFront={isFront ? isFront : 0}
          />
        </div>
      </div>
    </div>
  );
};

export default TrainerFeedbacks;
